import { RootState } from 'store';

export const selectMedia = (state:RootState) => state.media.media;
export const selectSelectedMedia = (state:RootState) => state.media.selectedMedia;
